import React from 'react';

import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { ForgeGlobalSettingsExtensionPoint } from '@confluence/forge-ui/entry-points/GlobalSettings';

export const AdminForgeAppsRoute = ({ params: { appId, envId, forgeManifestRoute } }) => {
	// Construct the module id from URL params to match the format expected by ForgeGlobalSettingsExtensionPoint
	// Format: ari:cloud:ecosystem::extension/{appId}/{envId}/static/{moduleKey}
	// This matches against app.id in the Forge extensions list
	const id = `ari:cloud:ecosystem::extension/${appId}/${envId}/static/${forgeManifestRoute}`;
	return <ForgeGlobalSettingsExtensionPoint key={id} id={id} />;
};

AdminForgeAppsRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: {
			name: 'adminForgeApps',
		},
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
